import { render, staticRenderFns } from "./toggleCollapse.vue?vue&type=template&id=5f5d5930&scoped=true"
import script from "./toggleCollapse.vue?vue&type=script&lang=js"
export * from "./toggleCollapse.vue?vue&type=script&lang=js"
import style0 from "./toggleCollapse.vue?vue&type=style&index=0&id=5f5d5930&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d5930",
  null
  
)

export default component.exports